import { Modal } from 'antd'
import { Done } from '@mui/icons-material'
import { Genre } from '../../Api/Lirari/Types/genre'
import { useState } from 'react'
import { genresAtom } from '../../State/Musician/genresAtom'
import { useAtom } from 'jotai'
import { Select } from 'antd'

const GenresModal = ({
  setGenres,
  setGenresModalOpen,
}: {
  setGenres: (genre: Genre[]) => void
  setGenresModalOpen: (value: boolean) => void
}) => {
  const [searchedGenres, setSearchedGenres] = useState<Genre[]>([])
  const [genres] = useAtom(genresAtom)

  const onSearch = (e: string) => {
    const filteredGenres = e ? genres.filter((genre) => genre.name.toLowerCase().includes(e.toLowerCase())) : undefined
    if (filteredGenres) setSearchedGenres(filteredGenres)
  }

  const onSelect = (value: string) => {
    const genre = genres.find((genre) => genre.name == value)
    if (genre) setSearchedGenres([...searchedGenres, genre])
  }

  const onDeselect = (value: string) => {
    const updatedGenres = searchedGenres.filter((genre) => genre.name != value)
    setSearchedGenres(updatedGenres)
  }

  return (
    <Modal centered open closable={false} onClose={() => setGenresModalOpen(false)} footer={[]}>
      <div className="flex flex-col items-center">
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder="Please select genres"
          filterOption={false}
          onSearch={onSearch}
          onSelect={onSelect}
          onDeselect={onDeselect}
          options={genres.map((genre) => ({ id: genre.id, value: genre.name }))}
        />

        <button
          className="flex justify-center h-12 w-12 rounded-full border-none bg-white hover:bg-[#cdcdcd]/90 [&>svg]:text-black p-0 mt-2.5 "
          onClick={() => {
            setGenres(searchedGenres)
            setGenresModalOpen(false)
          }}
        >
          <Done className="self-center" />
        </button>
      </div>
    </Modal>
  )
}

export default GenresModal
